import { MedicalPaOrdersAuthStatus } from "../../../../enums/medicalPaOrdersAuthStatus";

/**
 * Determines whether filter options should be displayed for a given worklist tab.
 *
 * Only tabs whose auth status is in the allowlist (`AuthRequired`, `Pending`,
 * `Hold`, and `Query`) will show the filter panel.
 *
 * @param tabId - The auth-status identifier of the active worklist tab.
 * @returns `true` if the tab supports filter options, `false` otherwise.
 */
export const shouldShowFilterOptions = (tabId: string) => {
  const authStatusToShowFilterOptions = [
    MedicalPaOrdersAuthStatus.AuthRequired,
    MedicalPaOrdersAuthStatus.Pending,
    MedicalPaOrdersAuthStatus.Hold,
    MedicalPaOrdersAuthStatus.Query,
  ];
  return authStatusToShowFilterOptions.includes(
    tabId as MedicalPaOrdersAuthStatus,
  );
};
